import { render, staticRenderFns } from "./P0121.vue?vue&type=template&id=0097ff4a&"
import script from "./P0121.vue?vue&type=script&lang=ts&"
export * from "./P0121.vue?vue&type=script&lang=ts&"
import style0 from "./P0121.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports